<template>
    <v-navigation-drawer style="z-index: 10000" fixed v-model="dialog" v-stack="{ open: dialog, close: hide }" right
        temporary height="100vh" color="surface"
        class="config-panel" :width="isMobile ? $vuetify.breakpoint.width : 320">

        <div class="config-panel-header">
            <v-btn icon small class="config-close" @click="hide">
                <v-icon size="16" color="txtSecondary">mdi-close</v-icon>
            </v-btn>
            <div class="config-panel-title">{{ $t('common.config') }}</div>
            <div class="header-spacer" />
        </div>

        <v-list class="config-list pa-0" color="transparent">

            <slot />

            <language-selector />

            <v-list-item class="config-item danger" @click="$emit('click:delete-account')">
                {{ $t('common.delete_account') }}
            </v-list-item>

            <v-list-item class="config-item danger" @click="onLogout">
                {{ $t('entrance.logout') }}
            </v-list-item>

        </v-list>
    </v-navigation-drawer>
</template>

<script>

import { logout } from '@/utils/Session'
import teleportToAppRoot from '@/mixins/teleportToAppRoot'
import LanguageSelector from '@/components/common/LanguageSelector'

const CLOSE_ANIMATION_MS = 300

export default {
    name: "ConfigDrawer",
    components: { LanguageSelector },
    mixins: [teleportToAppRoot],
    data() {
        return {
            dialog: false
        }
    },
    methods: {
        show() {
            this.dialog = true
        },
        hide() {
            this.dialog = false
        },
        async onLogout() {
            const vm = this
            vm.hide()
            await new Promise(resolve => setTimeout(resolve, CLOSE_ANIMATION_MS))
            await logout(vm.$router)
        },
    },
}

</script>

<style scoped>
.config-panel {
    border-left: 1px solid var(--v-outline-base);
    box-shadow: -8px 0 40px rgba(0, 0, 0, 0.4);
}

.config-panel-header {
    height: calc(56px + var(--safe-area-inset-top, 0px));
    padding-top: var(--safe-area-inset-top, 0px);
    display: flex;
    align-items: center;
    gap: 12px;
    padding-left: 16px;
    padding-right: 16px;
    border-bottom: 1px solid var(--v-outline-base);
    flex-shrink: 0;
}

.config-close {
    background: var(--v-surface2-base) !important;
}

.config-panel-title {
    font-size: 15px;
    font-weight: 600;
    color: var(--v-txtPrimary-base);
    flex: 1;
    text-align: center;
}

.header-spacer {
    width: 28px;
}

.config-list >>> .config-item {
    min-height: 0;
    padding: 16px 20px;
    font-size: 14px;
    font-weight: 500;
    color: var(--v-txtPrimary-base);
    border-bottom: 1px solid var(--v-outline-base);
}

.config-list >>> .config-item:last-child {
    border-bottom: none;
}

.config-list >>> .config-item.danger,
.config-list >>> .config-item.danger .v-list-item__title {
    color: var(--v-error-base);
}
</style>
